const locationSlider = () => {

    const sliderContainer = document.querySelector('.overflow-scroll')

    let isDown = false;
    let startX;
    let scrollLeft;
    if(sliderContainer){
        sliderContainer.addEventListener('mousedown', (e) => {
            isDown = true;
            sliderContainer.classList.add('active');
            startX = e.pageX - sliderContainer.offsetLeft;
            scrollLeft = sliderContainer.scrollLeft;
            sliderContainer.style.userSelect = 'none';
        });
        
        sliderContainer.addEventListener('mouseleave', () => {
            isDown = false;
            sliderContainer.classList.remove('active');
            sliderContainer.style.userSelect = '';
        });
        
        sliderContainer.addEventListener('mouseup', () => {
            isDown = false;
            sliderContainer.classList.remove('active');
            sliderContainer.style.userSelect = '';
        });
        
        sliderContainer.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - sliderContainer.offsetLeft;
            const walk = (x - startX) * 1;
            sliderContainer.scrollLeft = scrollLeft - walk;
        });
    }

}

export default locationSlider;